
import Responder from './responder';
import state from './state';
import {stringify, getHash, executeCallback, cloneObject} from './functions';

/**
 * A model always only exposes very few things:
 * model.status
 * model.error
 * model.data
 * model.meta
 * 
 * model.addResponder()
 */

class Model extends Responder{

    constructor(name=null, settings={}){

        super();
        this.name = name || ( 'model' + Math.round(999999*Math.random()) );

        this.status = 'inactive';    // inactive, waiting, failed, success
        this.error = '';
        
        // object holding information about the data (what is it), for
        // example the request parameters, but can also describe the
        // amount of returned results etc
        this.meta = null;   

        // data itself
        this.data = null;

        // object containing the select criteria
        this.select = {};
        this.hash = '';

        this.cache = false;
        this.cacheLimit = 20;

        if(settings.listeners){
            this.setListeners(settings.listeners);
        }

    }



    update(){

        // check what we need
        let select = this.getSelect();
        // see if current data matches that criteria
        // todo: order of the two object might be different, 
        // although the meaning is the same
        let hash = getHash(stringify(select));

        // sometimes the model relies on other "external" things
        // than the select value... Todo: search for better solution
        // if(hash === this.hash && this.status == 'success'){
        //     return;
        // }

        this.select = select;
        this.hash = hash;
        this.status = 'waiting';
        this.data = null;
        this.meta = null;
        this.error = null;

        this.getCache();

        if(this.status == 'success'){
            this.trigger();
        }else{
            this.fetchData();
        }

    }

    fetchData(){
        
        // call trigger() when data is loaded async

        // here comes the logic which data to select
        this.setData({});

    }

    setData(data, meta=null){
        this.data = data;
        this.meta = meta;
        this.status = 'success';

        this.setCache();

        this.trigger();
    }

    setError(error=null){
        if(!error){
            error = 'An unknown error occured while loading the data';
        }
        this.error = error;

        this.status = 'failed';

        this.trigger();
    }

    /**
     * Return object with select criteria, for example extracted
     * from the state object
     */
    getSelect(){

        return {};
    }

    setCache(){
        if(! this.cache || this.status != 'success'){
            return;
        }
        if(! this.cache.has(this.hash)){
            this.cache.set(this.hash, [cloneObject(this.meta), cloneObject(this.data)]);
            this.flushCache();
        }
    }

    getCache(){
        if(this.cache && this.cache.has(this.hash)){
            let data = this.cache.get(this.hash);
            this.meta = data[0];
            this.data = data[1];
            this.status = 'success';
            return true;
        }
        return false;
    }
    
    flushCache(limit=false){
        if(limit === false){
            limit = this.cacheLimit;
        }
        if(limit === true || limit == 0){
            this.cache.clear();
            return;
        }
        if(this.cache.size > limit){
            let remove = this.cache.size - limit;
            for(let v of this.cache){
                this.cache.delete(v);
                remove--;
                if(remove <= 0){
                    return;
                }
            }
        }
    }

    remove(){
        try{
            super.remove();
            if(this.cache){
                this.cache.clear();
            }
            delete this.cache;
            delete this.data;
            delete this.meta;
        }catch(e){
            console.warn('Error removing model: ' + e.message);
        }
    }

    trigger(name='*', args=false){
        if(! this.watchers){
            console.warn('Calling trigger on a deleted object');
            // this.watchers = new Set();
            return;
        }
        for(let w of this.watchers){
            if(name.length <= w.name.length){
                if(w.name.substring(0, name.length+1) == name+'.' || w.name == name || name == '*'){
                    let cb = w.callback;
                    if(args){
                        cb = w.callback.slice(0);
                        cb.push(...args);
                    }
                    executeCallback(cb);
                }
            }else if(name.substring(0, w.name.length+1) == w.name+'.'){
                let cb = w.callback;
                if(args){
                    cb = w.callback.slice(0);
                    cb.push(...args);
                }
                executeCallback(cb);
            }
        }
    }

}

export default Model;